'use client'

import { useMemo } from 'react'

import { NostoProductRecommendationsSection } from '../../../brunswick/components/NostoProductRecommendationsSection'
import { ErrorViewHead, ErrorViewSection } from '../../../brunswick/components/pages/ErrorView'
import { imageSrcs, relativePaths } from '../../../constants/figs'
import { canonicalBaseUrls } from '../../../constants/figs'
import { TrackPageView } from '../../_providers/TrackingProvider.client'
import { useTranslation } from '../../_providers/TranslationProvider.client'

/**
 * @deprecated This is only for Next.js pages directory. In app directory, use the
 * standardized notFound() function from 'next/navigation',
 * which should bubble up to the global-not-found.tsx component.
 */
export const NotFoundPage = () => {
  const {
    pages: {
      notFound: { canonicalPath: canonical404Path },
    },
  } = useTranslation()

  return (
    <>
      <ErrorViewHead canonicalUrl={`${canonicalBaseUrls.home}${canonical404Path}`} />
      <NotFoundPageContents />
    </>
  )
}

export const NotFoundPageContents = ({
  overrideHeading,
  overrideSubheading,
}: {
  overrideHeading?: string
  overrideSubheading?: string
}) => {
  const {
    pages: {
      notFound: {
        image: { alt },
        links,
        subheading,
        heading,
      },
    },
  } = useTranslation()

  const orderedLinks = useMemo(() => {
    return [
      {
        href: relativePaths.shopWomensBestSellersPath,
        title: links.shopWomen.title,
      },
      {
        href: relativePaths.shopMensBestSellersPath,
        title: links.shopMen.title,
      },
    ]
  }, [links.shopMen, links.shopWomen])

  return (
    <>
      <TrackPageView
        pageViewHandle='not-found'
        pageViewName='Not Found'
        pageViewCategory='not found'
      />
      <ErrorViewSection
        heading={overrideHeading ?? heading}
        subheading={overrideSubheading ?? subheading}
        imageAlt={alt}
        imageSrc={imageSrcs.notFound}
        links={orderedLinks}
      />

      <NostoProductRecommendationsSection
        nostoPlacementId='notfound-nosto-2'
        gutterSize='expanded'
      />

      <NostoProductRecommendationsSection
        nostoPlacementId='notfound-nosto-1'
        gutterSize='expanded'
      />
    </>
  )
}
